import { cancelRejectService } from '../../helpers/services/appointmentCancelReject.service';
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const CANCEL_REJECT_MODULE = 'appointmentCancelReject'; 

// define action 
export const GET_ALL_CANCEL_REJECT = 'getAllCancelReject';
export const GET_CANCEL_REJCET = 'getCancelReject';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_CANCEL_REJECT_REQUEST = "getAllCancelRejects";
const GET_CANCEL_REJECT_REQUEST = "getCancelReject";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_CANCEL_REJECT]({ commit }, { filter }) {
        cancelRejectService
            .getAllCancelReject(filter)
            .then(
                (result) => {
                    commit(GET_ALL_CANCEL_REJECT_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_CANCEL_REJCET]({ commit }, { id }) {
        cancelRejectService
            .getCancelReject(id)
            .then(
                (result) => {
                    commit(GET_CANCEL_REJECT_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "cancel-reject-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = {processing: true};
    },
    [GET_ALL_CANCEL_REJECT_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                remark: o.remark,
                mode: o.mode,
                appointment: o.appointment,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            }
        })
    },
    [GET_CANCEL_REJECT_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
                remark: o.remark,
                mode: o.mode,
                appointment: o.appointment,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
        }

    }
}


